<template>
    <div class="profile-container">
      <h1 class="profile-title">Profil</h1>
      <div class="profile-picture">
        <img :src="user.profilePicture" alt="Photo de profil" class="profile-img" />
        <input type="file" @change="uploadProfilePicture" class="upload-input" />
      </div>
      <div class="profile-form">
        <div class="form-group">
          <label>Nom :</label>
          <input v-model="user.name" type="text" />
        </div>
        <div class="form-group">
          <label>Email :</label>
          <input v-model="user.email" type="email" disabled />
        </div>
        <div class="form-group">
          <label>Téléphone :</label>
          <input v-model="user.phone" type="tel" />
        </div>
        <div class="form-group">
          <label>Adresse :</label>
          <textarea v-model="user.address"></textarea>
        </div>
        <button @click="updateProfile" class="update-button">Mettre à jour</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        user: {
          name: "",
          email: "",
          phone: "",
          address: "",
          profilePicture: "https://via.placeholder.com/150" // Image par défaut
        },
      };
    },
    mounted() {
      this.fetchUserProfile();
    },
    methods: {
      fetchUserProfile() {
        // Simuler une requête API pour récupérer les infos utilisateur
        this.user = {
          name: "John Doe",
          email: "john.doe@example.com",
          phone: "123456789",
          address: "123 Rue Principale, Ville, Pays",
          profilePicture: "https://via.placeholder.com/150"
        };
      },
      uploadProfilePicture(event) {
        const file = event.target.files[0];
        if (file) {
          this.user.profilePicture = URL.createObjectURL(file);
        }
      },
      updateProfile() {
        alert("Profil mis à jour !");
        // Envoyer les nouvelles données au backend ici
      },
    },
  };
  </script>
  
  <style scoped>
  .profile-container {
    max-width: 600px;
    margin: 40px auto;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 1px solid #ddd;
    text-align: center;
  }
  
  .profile-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }
  
  .profile-picture {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .profile-img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #007bff;
  }
  
  .upload-input {
    margin-top: 10px;
  }
  
  .profile-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .form-group {
    margin-bottom: 15px;
    width: 100%;
  }
  
  .form-group label {
    font-size: 16px;
    font-weight: 600;
    color: #555;
    display: block;
    margin-bottom: 5px;
  }
  
  .form-group input, .form-group textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.3s;
  }
  
  .form-group input:focus, .form-group textarea:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    outline: none;
  }
  
  .update-button {
    background: #007bff;
    color: white;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
  }
  
  .update-button:hover {
    background: #0056b3;
  }
  </style>
  